module.exports = __webpack_public_path__ + "_assets/img/fork.27e09440.svg";